// farmDataWeek.js  
export const farmDataday = {
    'PHHK-1': [
        { "Date": "2023-10-01", "kg": 60.00 },
        { "Date": "2023-10-03", "kg": 154.00 },
        { "Date": "2023-10-06", "kg": 224.00 },
        { "Date": "2023-10-07", "kg": 49.00 },
        { "Date": "2023-10-11", "kg": 342.00 },
        { "Date": "2023-10-12", "kg": 70.00 },
        { "Date": "2023-10-13", "kg": 98.00 },
        { "Date": "2023-10-14", "kg": 63.00 },
        { "Date": "2023-10-17", "kg": 238.00 },
        { "Date": "2023-10-18", "kg": 182.00 },
        { "Date": "2023-10-19", "kg": 105.00 },
        { "Date": "2023-10-20", "kg": 418.00 },
        { "Date": "2023-10-21", "kg": 191.00 },
        { "Date": "2023-10-22", "kg": 49.00 },
        { "Date": "2023-10-23", "kg": 168.00 },
        { "Date": "2023-10-24", "kg": 224.00 },
        { "Date": "2023-10-25", "kg": 238.00 },
        { "Date": "2023-10-26", "kg": 434.00 },
        { "Date": "2023-10-27", "kg": 238.00 },
        { "Date": "2023-10-28", "kg": 157.00 },
        { "Date": "2023-10-31", "kg": 455.00 },
        { "Date": "2023-11-01", "kg": 700.00 },
        { "Date": "2023-11-02", "kg": 203.00 },
        { "Date": "2023-11-03", "kg": 209.00 },
        { "Date": "2023-11-06", "kg": 343.00 },
        { "Date": "2023-11-09", "kg": 273.00 },
        { "Date": "2023-11-10", "kg": 248.00 },
        { "Date": "2023-11-11", "kg": 490.00 },
        { "Date": "2023-11-14", "kg": 455.00 },
        { "Date": "2023-11-15", "kg": 462.00 },
        { "Date": "2023-11-16", "kg": 539.00 },
        { "Date": "2023-11-18", "kg": 542.00 },
        { "Date": "2023-11-20", "kg": 238.00 },
        { "Date": "2023-11-21", "kg": 336.00 },
        { "Date": "2023-11-22", "kg": 224.00 },
        { "Date": "2023-11-23", "kg": 1134.00 },
        { "Date": "2023-11-25", "kg": 560.00 },
        { "Date": "2023-11-28", "kg": 788.00 },
        { "Date": "2023-11-29", "kg": 364.00 },
        { "Date": "2023-11-30", "kg": 140.00 },
        { "Date": "2023-12-04", "kg": 196.00 },
        { "Date": "2023-12-05", "kg": 140.00 },
        { "Date": "2023-12-06", "kg": 476.00 },
        { "Date": "2023-12-07", "kg": 350.00 },
        { "Date": "2023-12-08", "kg": 154.00 },
        { "Date": "2023-12-11", "kg": 301.00 },
        { "Date": "2023-12-12", "kg": 315.00 },
        { "Date": "2023-12-13", "kg": 210.00 },
        { "Date": "2023-12-14", "kg": 532.00 },
        { "Date": "2023-12-15", "kg": 588.00 },
        { "Date": "2023-12-18", "kg": 133.00 },
        { "Date": "2023-12-19", "kg": 350.00 },
        { "Date": "2023-12-20", "kg": 224.00 },
        { "Date": "2023-12-21", "kg": 350.00 },
        { "Date": "2023-12-22", "kg": 413.00 },
        { "Date": "2023-12-23", "kg": 364.00 },
        { "Date": "2023-12-25", "kg": 161.00 },
        { "Date": "2023-12-26", "kg": 343.00 },
        { "Date": "2023-12-27", "kg": 189.00 },
        { "Date": "2023-12-28", "kg": 54.00 },
        { "Date": "2024-01-04", "kg": 84.00 },
        { "Date": "2024-01-05", "kg": 749.00 },
        { "Date": "2024-01-08", "kg": 189.00 },
        { "Date": "2024-01-10", "kg": 483.00 },
        { "Date": "2024-01-11", "kg": 105.00 },
        { "Date": "2024-01-12", "kg": 144.00 },
        { "Date": "2024-01-15", "kg": 189.00 },
        { "Date": "2024-01-16", "kg": 238.00 },
        { "Date": "2024-01-17", "kg": 483.00 },
        { "Date": "2024-01-18", "kg": 441.00 },
        { "Date": "2024-01-19", "kg": 406.00 },
        { "Date": "2024-01-20", "kg": 460.00 },
        { "Date": "2024-01-22", "kg": 259.00 },
        { "Date": "2024-01-23", "kg": 147.00 },
        { "Date": "2024-01-24", "kg": 658.00 },
        { "Date": "2024-01-25", "kg": 77.00 },
        { "Date": "2024-01-26", "kg": 112.00 },
        { "Date": "2024-01-27", "kg": 154.00 },
        { "Date": "2024-01-29", "kg": 105.00 },
        { "Date": "2024-01-30", "kg": 126.00 },
        { "Date": "2024-01-31", "kg": 245.00 },
        { "Date": "2024-02-01", "kg": 175.00 },
        { "Date": "2024-02-02", "kg": 42.00 },
        { "Date": "2024-02-05", "kg": 49.00 },
        { "Date": "2024-02-07", "kg": 812.00 },
        { "Date": "2024-02-08", "kg": 259.00 },
        { "Date": "2024-02-09", "kg": 196.00 },
        { "Date": "2024-02-10", "kg": 112.00 },
        { "Date": "2024-02-14", "kg": 462.00 },
        { "Date": "2024-02-15", "kg": 378.00 },
        { "Date": "2024-02-16", "kg": 245.00 },
        { "Date": "2024-02-17", "kg": 147.00 },
        { "Date": "2024-02-19", "kg": 56.00 },
        { "Date": "2024-02-20", "kg": 126.00 },
        { "Date": "2024-02-21", "kg": 630.00 },
        { "Date": "2024-02-23", "kg": 503.00 },
        { "Date": "2024-02-26", "kg": 91.00 },
        { "Date": "2024-02-27", "kg": 91.00 },
        { "Date": "2024-02-28", "kg": 336.00 },
        { "Date": "2024-02-29", "kg": 259.00 },
        { "Date": "2024-03-01", "kg": 105.00 },
        { "Date": "2024-03-02", "kg": 161.00 },
        { "Date": "2024-03-04", "kg": 70.00 },
        { "Date": "2024-03-06", "kg": 427.00 },
        { "Date": "2024-03-07", "kg": 329.00 },
        { "Date": "2024-03-08", "kg": 154.00 },
        { "Date": "2024-03-09", "kg": 332.00 },
        { "Date": "2024-03-11", "kg": 77.00 },
        { "Date": "2024-03-12", "kg": 294.00 },
        { "Date": "2024-03-13", "kg": 357.00 },
        { "Date": "2024-03-14", "kg": 119.00 },
        { "Date": "2024-03-15", "kg": 154.00 },
        { "Date": "2024-03-18", "kg": 98.00 },
        { "Date": "2024-03-19", "kg": 231.00 },
        { "Date": "2024-03-20", "kg": 230.00 },
        { "Date": "2024-03-21", "kg": 203.00 },
        { "Date": "2024-03-22", "kg": 369.00 },
        { "Date": "2024-03-25", "kg": 35.00 },
        { "Date": "2024-03-26", "kg": 168.00 },
        { "Date": "2024-03-27", "kg": 460.00 },
        { "Date": "2024-03-28", "kg": 300.00 },
        { "Date": "2024-03-29", "kg": 288.00 },
        { "Date": "2024-04-01", "kg": 50.00 },
        { "Date": "2024-04-02", "kg": 160.00 },
        { "Date": "2024-04-03", "kg": 660.00 },
        { "Date": "2024-04-04", "kg": 390.00 },
        { "Date": "2024-04-05", "kg": 210.00 },
        { "Date": "2024-04-06", "kg": 130.00 },
        { "Date": "2024-04-08", "kg": 120.00 },
        { "Date": "2024-04-09", "kg": 160.00 },
        { "Date": "2024-04-10", "kg": 970.00 },
        { "Date": "2024-04-12", "kg": 88.00 },
        { "Date": "2024-04-15", "kg": 80.00 },
        { "Date": "2024-04-16", "kg": 160.00 },
        { "Date": "2024-04-17", "kg": 480.00 },
        { "Date": "2024-04-18", "kg": 320.00 },
        { "Date": "2024-04-19", "kg": 124.00 },
        { "Date": "2024-04-22", "kg": 160.00 },
        { "Date": "2024-04-24", "kg": 1170.00 },
        { "Date": "2024-04-25", "kg": 280.00 },
        { "Date": "2024-04-26", "kg": 269.00 },
        { "Date": "2024-04-29", "kg": 130.00 },
        { "Date": "2024-04-30", "kg": 510.00 },
        { "Date": "2024-05-01", "kg": 431.00 },
        { "Date": "2024-05-06", "kg": 50.00 },
        { "Date": "2024-05-07", "kg": 160.00 },
        { "Date": "2024-05-08", "kg": 680.00 },
        { "Date": "2024-05-09", "kg": 340.00 },
        { "Date": "2024-05-10", "kg": 480.00 },
        { "Date": "2024-05-11", "kg": 369.00 },
        { "Date": "2024-05-13", "kg": 140.00 },
        { "Date": "2024-05-14", "kg": 100.00 },
        { "Date": "2024-05-15", "kg": 460.00 },
        { "Date": "2024-05-16", "kg": 340.00 },
        { "Date": "2024-05-17", "kg": 50.00 },
        { "Date": "2024-05-20", "kg": 270.00 },
        { "Date": "2024-05-21", "kg": 60.00 },
        { "Date": "2024-05-22", "kg": 570.00 },
        { "Date": "2024-05-23", "kg": 260.00 },
        { "Date": "2024-05-24", "kg": 255.00 },
        { "Date": "2024-05-25", "kg": 44.00 },
        { "Date": "2024-05-27", "kg": 160.00 },
        { "Date": "2024-05-29", "kg": 760.00 },
        { "Date": "2024-05-30", "kg": 190.00 },
        { "Date": "2024-05-31", "kg": 340.00 },
        { "Date": "2024-06-01", "kg": 315.00 },
        { "Date": "2024-06-03", "kg": 80.00 },
        { "Date": "2024-06-04", "kg": 120.00 },
        { "Date": "2024-06-05", "kg": 560.00 },
        { "Date": "2024-06-06", "kg": 160.00 },
        { "Date": "2024-06-07", "kg": 320.00 },
        { "Date": "2024-06-08", "kg": 120.00 },
        { "Date": "2024-06-10", "kg": 140.00 },
        { "Date": "2024-06-12", "kg": 570.00 },
        { "Date": "2024-06-13", "kg": 510.00 },
        { "Date": "2024-06-14", "kg": 290.00 },
        { "Date": "2024-06-15", "kg": 154.00 },
        { "Date": "2024-06-17", "kg": 130.00 },
        { "Date": "2024-06-19", "kg": 390.00 },
        { "Date": "2024-06-20", "kg": 420.00 },
        { "Date": "2024-06-21", "kg": 200.00 },
        { "Date": "2024-06-24", "kg": 110.00 },
        { "Date": "2024-06-26", "kg": 570.00 },
        { "Date": "2024-06-27", "kg": 440.00 },
        { "Date": "2024-06-28", "kg": 252.00 },
        { "Date": "2024-07-01", "kg": 130.00 },
        { "Date": "2024-07-03", "kg": 610.00 },
        { "Date": "2024-07-04", "kg": 274.00 },
        { "Date": "2024-07-08", "kg": 150.00 },
        { "Date": "2024-07-10", "kg": 580.00 },
        { "Date": "2024-07-11", "kg": 220.00 },
        { "Date": "2024-07-12", "kg": 281.00 },
        { "Date": "2024-07-16", "kg": 90.00 },
        { "Date": "2024-07-17", "kg": 170.00 },
        { "Date": "2024-07-18", "kg": 160.00 },
        { "Date": "2024-07-19", "kg": 355.00 },
        { "Date": "2024-07-22", "kg": 140.00 },
        { "Date": "2024-07-24", "kg": 360.00 },
        { "Date": "2024-07-25", "kg": 360.00 },
        { "Date": "2024-07-26", "kg": 210.00 },
        { "Date": "2024-07-27", "kg": 215.00 },
        { "Date": "2024-07-29", "kg": 80.00 },
        { "Date": "2024-07-30", "kg": 140.00 },
        { "Date": "2024-07-31", "kg": 160.00 },
        { "Date": "2024-08-01", "kg": 155.00 },
        { "Date": "2024-08-02", "kg": 0.00 },
        { "Date": "2024-08-03", "kg": 0.00 },
        { "Date": "2024-08-04", "kg": 0.00 },
        { "Date": "2024-08-05", "kg": 0.00 },
        { "Date": "2024-08-06", "kg": 0.00 },
        { "Date": "2024-08-07", "kg": 0.00 },
        { "Date": "2024-08-08", "kg": 0.00 },
        { "Date": "2024-08-09", "kg": 0.00 },
        { "Date": "2024-08-10", "kg": 0.00 },
        { "Date": "2024-08-11", "kg": 0.00 },
        { "Date": "2024-08-12", "kg": 0.00 },
        { "Date": "2024-08-13", "kg": 0.00 },
        { "Date": "2024-08-14", "kg": 0.00 },
        { "Date": "2024-08-15", "kg": 0.00 },
        { "Date": "2024-08-16", "kg": 0.00 },
        { "Date": "2024-08-17", "kg": 0.00 },
        { "Date": "2024-08-18", "kg": 0.00 },
        { "Date": "2024-08-19", "kg": 0.00 },
        { "Date": "2024-08-20", "kg": 0.00 },
        { "Date": "2024-08-21", "kg": 0.00 },
        { "Date": "2024-08-22", "kg": 0.00 },
        { "Date": "2024-08-23", "kg": 0.00 },
        { "Date": "2024-08-24", "kg": 0.00 },
        { "Date": "2024-08-25", "kg": 0.00 },
        { "Date": "2024-08-26", "kg": 0.00 },
        { "Date": "2024-08-27", "kg": 0.00 },
        { "Date": "2024-08-28", "kg": 0.00 },
        { "Date": "2024-08-29", "kg": 0.00 },
        { "Date": "2024-08-30", "kg": 0.00 },
        { "Date": "2024-08-31", "kg": 0.00 },
        { "Date": "2024-09-01", "kg": 0.00 },
        { "Date": "2024-09-02", "kg": 0.00 },
        { "Date": "2024-09-03", "kg": 0.00 },
        { "Date": "2024-09-04", "kg": 0.00 },
        { "Date": "2024-09-05", "kg": 0.00 },
        { "Date": "2024-09-06", "kg": 0.00 },
        { "Date": "2024-09-07", "kg": 0.00 },
        { "Date": "2024-09-08", "kg": 0.00 },
        { "Date": "2024-09-09", "kg": 0.00 },
        { "Date": "2024-09-10", "kg": 0.00 },
        { "Date": "2024-09-11", "kg": 0.00 },
        { "Date": "2024-09-12", "kg": 0.00 },
        { "Date": "2024-09-13", "kg": 0.00 },
        { "Date": "2024-09-14", "kg": 0.00 },
        { "Date": "2024-09-15", "kg": 0.00 },
        { "Date": "2024-09-16", "kg": 0.00 },
        { "Date": "2024-09-17", "kg": 0.00 },
        { "Date": "2024-09-18", "kg": 0.00 },
        { "Date": "2024-09-19", "kg": 0.00 },
        { "Date": "2024-09-20", "kg": 0.00 },
        { "Date": "2024-09-21", "kg": 0.00 },
        { "Date": "2024-09-22", "kg": 0.00 },
        { "Date": "2024-09-23", "kg": 0.00 },
        { "Date": "2024-09-24", "kg": 0.00 },
        { "Date": "2024-09-25", "kg": 0.00 },
        { "Date": "2024-09-26", "kg": 0.00 },
        { "Date": "2024-09-27", "kg": 0.00 },
        { "Date": "2024-09-28", "kg": 0.00 },
        { "Date": "2024-09-29", "kg": 0.00 },
        { "Date": "2024-09-30", "kg": 0.00 },
        { "Date": "2024-10-01", "kg": 0.00 }
    ],
    'THSN': [
        { "Date": "2023-09-12", "kg": 57.60 },
        { "Date": "2023-09-13", "kg": 21.43 },
        { "Date": "2023-09-19", "kg": 159.95 },
        { "Date": "2023-09-22", "kg": 133.50 },
        { "Date": "2023-09-24", "kg": 152.40 },
        { "Date": "2023-09-27", "kg": 172.80 },
        { "Date": "2023-09-28", "kg": 237.90 },
        { "Date": "2023-10-02", "kg": 188.50 },
        { "Date": "2023-10-04", "kg": 194.60 },
        { "Date": "2023-10-05", "kg": 265.70 },
        { "Date": "2023-10-06", "kg": 86.10 },
        { "Date": "2023-10-10", "kg": 52.00 },
        { "Date": "2023-10-11", "kg": 115.50 },
        { "Date": "2023-10-12", "kg": 352.80 },
        { "Date": "2023-10-13", "kg": 139.60 },
        { "Date": "2023-10-17", "kg": 148.00 },
        { "Date": "2023-10-18", "kg": 286.80 },
        { "Date": "2023-10-19", "kg": 232.60 },
        { "Date": "2023-10-20", "kg": 113.40 },
        { "Date": "2023-10-23", "kg": 245.60 },
        { "Date": "2023-10-24", "kg": 186.10 },
        { "Date": "2023-10-25", "kg": 335.00 },
        { "Date": "2023-10-26", "kg": 139.80 },
        { "Date": "2023-10-27", "kg": 64.90 },
        { "Date": "2023-10-30", "kg": 162.70 },
        { "Date": "2023-10-31", "kg": 171.10 },
        { "Date": "2023-11-02", "kg": 386.60 },
        { "Date": "2023-11-06", "kg": 252.90 },
        { "Date": "2023-11-07", "kg": 407.70 },
        { "Date": "2023-11-10", "kg": 141.30 },
        { "Date": "2023-11-13", "kg": 198.90 },
        { "Date": "2023-11-14", "kg": 137.80 },
        { "Date": "2023-11-15", "kg": 358.50 },
        { "Date": "2023-11-16", "kg": 463.90 },
        { "Date": "2023-11-24", "kg": 375.73 },
        { "Date": "2023-11-28", "kg": 237.40 },
        { "Date": "2023-11-29", "kg": 304.40 },
        { "Date": "2023-12-01", "kg": 534.50 },
        { "Date": "2023-12-05", "kg": 556.20 },
        { "Date": "2023-12-06", "kg": 190.00 },
        { "Date": "2023-12-19", "kg": 146.00 },
        { "Date": "2023-12-20", "kg": 173.00 },
        { "Date": "2023-12-21", "kg": 195.00 },
        { "Date": "2023-12-22", "kg": 140.92 },
        { "Date": "2023-12-25", "kg": 170.00 },
        { "Date": "2023-12-26", "kg": 470.00 },
        { "Date": "2023-12-27", "kg": 107.40 },
        { "Date": "2023-12-28", "kg": 700.00 },
        { "Date": "2024-01-12", "kg": 115.00 },
        { "Date": "2024-01-15", "kg": 167.00 },
        { "Date": "2024-01-16", "kg": 273.00 },
        { "Date": "2024-01-17", "kg": 257.00 },
        { "Date": "2024-01-18", "kg": 264.00 },
        { "Date": "2024-01-19", "kg": 184.00 },
        { "Date": "2024-01-22", "kg": 90.00 },
        { "Date": "2024-01-23", "kg": 193.00 },
        { "Date": "2024-01-24", "kg": 117.20 },
        { "Date": "2024-01-25", "kg": 188.90 },
        { "Date": "2024-01-26", "kg": 152.00 },
        { "Date": "2024-01-29", "kg": 72.00 },
        { "Date": "2024-01-30", "kg": 187.00 },
        { "Date": "2024-01-31", "kg": 236.00 },
        { "Date": "2024-02-01", "kg": 152.00 },
        { "Date": "2024-02-02", "kg": 136.00 },
        { "Date": "2024-02-06", "kg": 35.70 },
        { "Date": "2024-02-07", "kg": 97.00 },
        { "Date": "2024-02-13", "kg": 122.50 },
        { "Date": "2024-02-14", "kg": 129.30 },
        { "Date": "2024-02-15", "kg": 101.00 },
        { "Date": "2024-02-16", "kg": 150.00 },
        { "Date": "2024-02-19", "kg": 89.00 },
        { "Date": "2024-02-20", "kg": 203.00 },
        { "Date": "2024-02-21", "kg": 182.10 },
        { "Date": "2024-02-22", "kg": 154.10 },
        { "Date": "2024-02-27", "kg": 163.90 },
        { "Date": "2024-02-28", "kg": 61.70 },
        { "Date": "2024-02-29", "kg": 204.00 },
        { "Date": "2024-03-01", "kg": 155.10 },
        { "Date": "2024-03-04", "kg": 91.50 },
        { "Date": "2024-03-05", "kg": 98.20 },
        { "Date": "2024-03-06", "kg": 170.40 },
        { "Date": "2024-03-07", "kg": 182.00 },
        { "Date": "2024-03-08", "kg": 29.50 },
        { "Date": "2024-03-11", "kg": 84.40 },
        { "Date": "2024-03-12", "kg": 166.20 },
        { "Date": "2024-03-13", "kg": 129.20 },
        { "Date": "2024-03-14", "kg": 147.80 },
        { "Date": "2024-03-15", "kg": 157.90 },
        { "Date": "2024-03-18", "kg": 100.00 },
        { "Date": "2024-03-19", "kg": 134.10 },
        { "Date": "2024-03-21", "kg": 260.00 },
        { "Date": "2024-03-22", "kg": 64.80 },
        { "Date": "2024-03-25", "kg": 141.80 },
        { "Date": "2024-03-26", "kg": 309.20 },
        { "Date": "2024-03-27", "kg": 389.40 },
        { "Date": "2024-03-28", "kg": 399.40 },
        { "Date": "2024-03-29", "kg": 122.40 },
        { "Date": "2024-04-02", "kg": 224.70 },
        { "Date": "2024-04-03", "kg": 321.40 },
        { "Date": "2024-04-04", "kg": 602.30 },
        { "Date": "2024-04-05", "kg": 235.60 },
        { "Date": "2024-04-08", "kg": 280.30 },
        { "Date": "2024-04-09", "kg": 250.30 },
        { "Date": "2024-04-10", "kg": 187.80 },
        { "Date": "2024-04-11", "kg": 293.00 },
        { "Date": "2024-04-12", "kg": 53.80 },
        { "Date": "2024-04-15", "kg": 160.00 },
        { "Date": "2024-04-16", "kg": 165.70 },
        { "Date": "2024-04-17", "kg": 171.80 },
        { "Date": "2024-04-18", "kg": 113.40 },
        { "Date": "2024-04-19", "kg": 120.60 },
        { "Date": "2024-04-22", "kg": 117.80 },
        { "Date": "2024-04-23", "kg": 258.40 },
        { "Date": "2024-04-24", "kg": 160.00 },
        { "Date": "2024-04-25", "kg": 261.10 },
        { "Date": "2024-04-26", "kg": 106.80 },
        { "Date": "2024-04-27", "kg": 18.30 },
        { "Date": "2024-04-30", "kg": 310.00 },
        { "Date": "2024-05-01", "kg": 371.90 },
        { "Date": "2024-05-07", "kg": 152.70 },
        { "Date": "2024-05-08", "kg": 279.40 },
        { "Date": "2024-05-09", "kg": 341.40 },
        { "Date": "2024-05-10", "kg": 223.00 },
        { "Date": "2024-05-13", "kg": 487.30 },
        { "Date": "2024-05-14", "kg": 140.90 },
        { "Date": "2024-05-15", "kg": 210.40 },
        { "Date": "2024-05-16", "kg": 106.40 },
        { "Date": "2024-05-20", "kg": 114.90 },
        { "Date": "2024-05-21", "kg": 99.80 },
        { "Date": "2024-05-22", "kg": 344.70 },
        { "Date": "2024-05-23", "kg": 171.90 },
        { "Date": "2024-05-24", "kg": 284.90 },
        { "Date": "2024-05-27", "kg": 209.00 },
        { "Date": "2024-05-28", "kg": 347.50 },
        { "Date": "2024-05-29", "kg": 257.30 },
        { "Date": "2024-05-30", "kg": 280.00 },
        { "Date": "2024-05-31", "kg": 161.80 },
        { "Date": "2024-06-03", "kg": 147.50 },
        { "Date": "2024-06-04", "kg": 333.50 },
        { "Date": "2024-06-05", "kg": 233.70 },
        { "Date": "2024-06-06", "kg": 224.10 },
        { "Date": "2024-06-07", "kg": 370.20 },
        { "Date": "2024-06-10", "kg": 264.90 },
        { "Date": "2024-06-11", "kg": 334.20 },
        { "Date": "2024-06-12", "kg": 218.00 },
        { "Date": "2024-06-13", "kg": 289.00 },
        { "Date": "2024-06-14", "kg": 128.60 },
        { "Date": "2024-06-17", "kg": 80.60 },
        { "Date": "2024-06-18", "kg": 282.00 },
        { "Date": "2024-06-19", "kg": 347.30 },
        { "Date": "2024-06-20", "kg": 331.40 },
        { "Date": "2024-06-25", "kg": 457.90 },
        { "Date": "2024-06-26", "kg": 328.70 },
        { "Date": "2024-06-27", "kg": 590.00 },
    ]
};

